import { render, staticRenderFns } from "./refund_order_page.vue?vue&type=template&id=31e924b6&scoped=true"
import script from "./refund_order_page.vue?vue&type=script&lang=js"
export * from "./refund_order_page.vue?vue&type=script&lang=js"
import style0 from "./refund_order_page.vue?vue&type=style&index=0&id=31e924b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e924b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e924b6')) {
      api.createRecord('31e924b6', component.options)
    } else {
      api.reload('31e924b6', component.options)
    }
    module.hot.accept("./refund_order_page.vue?vue&type=template&id=31e924b6&scoped=true", function () {
      api.rerender('31e924b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/refund_order_page.vue"
export default component.exports